import $ from 'jquery';

export default {
	init() {
		// Announce filter results for screen readers
		$(document).on('facetwp-loaded', function () {
			var $announcement = $('#facetwp-results-announcement');
			if ($announcement.length) {
				// Get total results from FacetWP pager settings
				var totalResults =
					FWP.settings.pager && FWP.settings.pager.total_rows
						? FWP.settings.pager.total_rows
						: FWP.settings.num_results || 0;

				var selectedCategoryText = $(
					'.facetwp-facet[data-name="categories"] option:selected'
				).text();

				// Clean up category text: trim spaces and remove count in parentheses
				var selectedCategory = selectedCategoryText.trim().replace(/\s*\(\d+\)\s*$/, '');

				var message = totalResults + ' post' + (totalResults !== 1 ? 's' : '') + ' loaded';
				if (selectedCategory && selectedCategory !== 'Any' && selectedCategory !== '') {
					message += ' for category: ' + selectedCategory;
				}
				$announcement.text(message);
			}
		});
	},
};
